import styled from "styled-components";

export const VerifyAccountWrapper = styled.div`  
    position: relative;
    overflow: auto;
    height: 100%;
    width: 100vw;
`;

export const VerifyAccountBox = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100%;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  padding: 48px 0px 30px 0px;
  background-color: #fff;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 48px 15px 15px;
  }

  @media (max-width: 700px) {
    max-width: 100%;
  }
`;

export const LoginLogoSpan = styled.span`
  margin: 0 -3px;
  font-size: 18px;
  font-weight: 300;  
`;

export const VerifyAccountLogo = styled.div`
    display: flex;
    align-content: center;
    flex-direction: column;
`;

export const VerifyAccountContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0 26px;
    font-size: 16px;
    margin-top: 44px;
    margin-bottom: 10vh;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: flex-start;
    border-top: 1px solid #EBEDF2;
    @media(max-width: 1024px) {
        padding-top: 2vh;
    }
    @media(max-width: 426px) {
        font-size: 15px;
    }
`;
export const VerifyAccountFormBox = styled.div`
    margin: 44px auto 0px auto;
    max-width: 472px;
`;

export const VerifyAccountTitle = styled.span`
    width: 100%;
    margin-bottom: 15px;
    font-size: 1.5em;
    color: #2B323B;
    font-weight: 600;
    line-height: 120%;
    font-style: normal;
    text-align: center;
    letter-spacing: -0.02em;
    font-family: 'Proxima Nova';
`;

export const VerfyAccountForm = styled.form`
    width: 100%;
    margin-bottom: 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 24px;
`;

export const VerifyAccountLabel = styled.h3`
    height: 24px;
    font-size: 1em;
    color: #38424D;
    font-weight: 600;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 4px;
    letter-spacing: -0.35px;
    font-family: 'Proxima Nova';
`;

export const AcceptTermsConditionsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
`;
export const AcceptTermsConditions = styled.label`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    a {
        color: #017CFF;
    }
`;

export const SuccessExistAccountBox = styled.section`
    margin: 44px auto 0px auto;
    max-width: 770px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SuccessAccountBox = styled.section`
    margin: 44px auto 0px auto;
    max-width: 653px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TitleVerifyAccount = styled.label`
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: -2%;
    color: #2B323B;
    text-align: center;
` 
export const ParagraphAccount = styled.span`
    margin-top: 6px;
    font-size: 19px;
    font-weight: 400;
    line-height: 23px;
    text-align: center;
    span#success-exist {
        font-weight: 700;
    }
    color: #2B323B;
`;

export const ParagraphAccountSuccess = styled.span`
    margin-top: 6px;
    font-size: 24px;
    font-weight: 500;
    line-height: 23px;
    text-align: center;
    span#success-only {
        color: #017CFF;
    }
    color: #2B323B;
`;

export const DateInformationExpired = styled.span`
    margin-top: 6px;
    font-size: 24px;
    font-weight: 700;
    line-height: 23px;
    text-align: center;
    color: #2B323B;
    span {
        color: #FF0000
    }
`
export const ButtonAccountVerifyBox = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 6px;
`

